import slider1 from '../../images/sliders/1.png'
import slider2 from '../../images/sliders/2.png'
import slider3 from '../../images/sliders/3.png'

export const sliders = [
    {
        'image': slider1,
        'className': 'left-15/100 text-left',
        'subtitle': 'We Pride Ourselves With A',
        'title': 'Team of proffesionals',
        'btn-text': 'Read More',
        'link': '#',
        'animation': ['fadeInDown', 'fadeInRight', 'fadeInUp'],
    },
    {
        'image': slider2,
        'className': 'right-15/100 text-right',
        'subtitle': 'We Provide',
        'title': 'Reliable Machinery',
        'btn-text': 'Read More',
        'link': '#',
        'animation': ['fadeInDown', 'fadeInLeft', 'fadeInUp'],
    },
    {
        'image': slider3,
        'className': 'text-center right-15/100 left-15/100',
        'subtitle': 'We Offer',
        'title': 'Affordable Prices',
        'btn-text': 'Read More',
        'link': '#',
        'animation': ['fadeInDown', 'fadeInUp', 'fadeInUp'],
    },
]